// Vendors
import styled from 'styled-components';
import { getStyles } from '@kubit/web-ui-components';
import { MEDIA_QUERIES } from '../../designSystem/reloaded/commons/foundations';
const FooterWrapperStyled = styled.div `
  ${({ styles }) => getStyles(styles?.container)}
  width: auto;

  ${MEDIA_QUERIES.mobileAndTablet} {
    width: 100%;
  }
`;
FooterWrapperStyled.displayName = 'FooterWrapperStyled';
const FooterWrapperButtonsStyled = styled.div `
  ${({ styles }) => getStyles(styles?.buttonsContainer)}
`;
FooterWrapperButtonsStyled.displayName = 'FooterWrapperButtonsStyled';
export { FooterWrapperStyled, FooterWrapperButtonsStyled };
//# sourceMappingURL=footer.component.styled.js.map